"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductListFilterItemSelect = void 0;
const ProductListFilterItem_1 = require("./ProductListFilterItem");
class ProductListFilterItemSelect extends ProductListFilterItem_1.ProductListFilterItem {
    constructor(filterItemData) {
        super(filterItemData);
        this.rootValues = this.values;
        this._value = this.getValueFromResult(filterItemData);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value.filter((item) => {
            return this.rootValues.has(item);
        });
    }
    get paramValue() {
        return this.value.join(",");
    }
    clear() {
        this._value = [];
    }
    getValueFromResult(filterItemData) {
        if (filterItemData.values.length !== this.rootValues.size) {
            return filterItemData.values.map((value) => value.id);
        }
        return [];
    }
    applyFilterItemResult(filterItem) {
        this._value = this.getValueFromResult(filterItem);
    }
}
exports.ProductListFilterItemSelect = ProductListFilterItemSelect;
